module.exports = __webpack_public_path__ + "img/menu.47c089d1.png";